module.exports = __webpack_public_path__ + "static/media/Download.f47ff539.svg";